export class AppSettings {
    public static MAIN_MENU_ITEMS = [
        {"name": "Licensing", "route": 'licensing', "icon": "file-text"},
        {"name": "Utilities", "route": 'utilities', "icon": "eject"},
        {"name": "Pricing", "route": 'pricing', "icon": "dollar"},
        {"name": "Platform", "route": 'platform', "icon": "desktop"},
        {"name": "Partner Component", "route": 'partner-component', "icon": 'handshake-o'}
    ];
    public static TOGGLE = 'toggle';
    public static VIEW = 'view';
    public static DOWNLOAD = 'download';
    public static EDIT = 'edit';
    public static DELETE = 'delete';
    public static CREATE = 'create';
    public static GENERATE = 'generate';
    public static SUCCESS_CODES = [200, 201, 204];
    public static ERRORCODES = {
        "TIME_OUT": 504,
        "BAD_REQUEST": 400
    }
    public static HTTP_METHODS = {
        "GET": "GET",
        "POST": "POST",
        "DELETE": "DELETE",
        "PUT": "PUT"
    }
    public static licenseFilterOptions = [
        {
            "displayValue": "All",
            "value": "all"
        },
        {
            "displayValue": "Paid",
            "value": "paid"
        },
        {
            "displayValue": "Trial",
            "value": "trial"
        }
    ];
    public static userFilterOptions = [
        {
            "displayValue": "All",
            "value": "all"
        },
        {
            "displayValue": "Admin",
            "value": "admin"
        },
        {
            "displayValue": "User",
            "value": "user"
        }
    ];
    public static pricingFilterOptions = [
        {
            "displayValue": "All",
            "value": "all"
        },
        {
            "displayValue": "Paid",
            "value": "paid"
        },
        {
            "displayValue": "Trial",
            "value": "trial"
        }
    ];
    public static LICENSING_TABLE_COLUMNS = [
        {"name": 'customerCode', "title": "Customer Code", "isSortField": true},
        {"name": "startDate" ,"title": 'Start Date', "isSortField": true},
        {"name": "endDate" ,"title": 'End Date', "isSortField": true},
        {"name": "userCount", "title": "User Count", "isSortField": true},
        {"name": "licenseType", "title": "License Type"},
        {"name": "totalCost", "title": "Cost", "isSortField": true},
        {"name": "buttons", "title": "License Status", "type": AppSettings.TOGGLE},
        {"name": "controls", "title": 'Controls'}
    ];
    public static PRICING_TABLE_COLUMNS = [
        {"name": 'item', "title": "Item", "isSortField": true},
        {"name": "itemCost" ,"title": 'Cost'},
        {"name": "description", "title": "Description"},
        {"name": "controls", "title": 'Controls'}
    ];
    public static UTILITIES_TABLE_COLUMNS = [
        {"name": 'name', "title": "Utilities Name", "isSortField": true},
        {"name": "controls", "title": 'Controls'}
      ];
    public static MANAGE_USER_TABLE_COLUMNS = [
        {"name": 'username', "title": "User Name", "isSortField": true},
        {"name": "email" ,"title": 'Email', "isSortField": true},
        {"name": "role" ,"title": 'Role'},
        {"name": "buttons", "title": "User Status", "type": AppSettings.TOGGLE},
        {"name": "controls", "title": 'Controls'}
    ];
    public static PLATFORM_TABLE_COLUMNS = [
        {"name": 'platformName', "title": "Platform Name", "isSortField": true},
        {"name": "accessKeyExpiry" ,"title": 'Access Key Expiry', "isSortField": true},
        {"name": "generatedBy" ,"title": 'Generated By', "isSortField": true},
        {"name": "generatedOn", "title": "Generated On"},
        {"name": "buttons", "title": "Platform Status", "type": AppSettings.TOGGLE},
        {"name": "controls", "title": 'Controls'}
      ];
      public static PARTNER_COMPONENT_TABLE_COLUMNS = [
        {"name": 'componentName', "title": "Name", "isSortField": true},
        {"name": "basePrice" ,"title": 'Base Price', "isSortField": true},
        {"name": "componentDescription", "title": "Description"},
        {"name": "controls", "title": 'Controls'}
    ];
    public static CREATE_LICENSE_TYPE = [
        {
            "displayValue": "Paid",
            "value": "paid"
        },
        {
            "displayValue": "Trial",
            "value": "trial"
        }
    ];
    public static MM_DD_YYYY = "mmddyyyy";
    public static DD_MM_YYYY = "ddmmyyyy";
    public static YYYY_MM_DD = "yyyymmdd";
   
    public static TOKEN_KEY = 'auth-token';
    public static USER_KEY = 'auth-user';
    public static USER_ROLE = 'userRole';
    public static LOGIN_ROUTE = "login";
    public static DEFAULT_ROUTE = "/";
    public static BYPASS_ROUTES = ["login"];
    public static TOKEN_EXPIRE_CODE = 401;
    public static USER_ROLES = { 
        "USER": "USER", 
        "ADMIN": "ADMIN"
    };
    public static MODULES = {
        "LICENSING": "LICENSING",
        "UTILITY": "UTILITY",
        "PRICING": "PRICING",
        "PLATFORM": "PLATFORM",
        "MANAGE_USER": "MANAGE_USER",
        "PARTNER_COMPONENT": "PARTNER_COMPONENT"
    }
    public static ACTIONS = {
        "VIEW": "VIEW",
        "EDIT": "EDIT",
        "CREATE": "CREATE",
        "DELETE": "DELETE",
        "DOWNLOAD": "DOWNLOAD",
        "GENERATE": "GENERATE"
    }
    public static ACTION_TITLE = {
        "VIEW": "View",
        "CREATE": "Create New",
        "EDIT": "Edit",
        "DELETE": "Delete",
        "DOWNLOAD": "Download",
        "GENERATE": "Generate",
        "DELETE_DISABLE": "Delete is not allowed for active user."
    }
    public static ACTION_ICONS = {
        "VIEW": "eye",
        "CREATE": "plus",
        "EDIT": "pencil-square-o",
        "DELETE": "trash",
        "DOWNLOAD": "download",
        "GENERATE": "key"
    }
    public static USER_ROLE_ACTION_MAP = {
        "LICENSING": {
            "ADMIN": ["VIEW", "DOWNLOAD", "EDIT",  "DELETE", "CREATE"],
            "USER": ["VIEW"]
        },
        "UTILITY": {
            "ADMIN": ["VIEW", "EDIT", "DELETE", "CREATE"],
            "USER": ["VIEW"]
        },
        "PLATFORM": {
            "ADMIN": ["VIEW", "GENERATE", "DELETE", "CREATE"],
            "USER": ["VIEW"]
        },
        "PRICING": {
            "ADMIN": ["VIEW", "EDIT", "DELETE", "CREATE"],
            "USER": ["VIEW"]
        },
        "MANAGE_USER": {
            "ADMIN": ["VIEW", "EDIT", "DELETE"],
            "USER": []
        },
        "PARTNER_COMPONENT": {
            "ADMIN": ["VIEW", "EDIT", "DELETE", "CREATE"],
            "USER": ["VIEW"]
        }
    }
    public static ROUTE_MODULE_MAP = {
        "licensing": "LICENSING",
        "utilities": "UTILITY",
        "platform": "PLATFORM",
        "pricing": "PRICING",
        "manage-user": "MANAGE_USER",
        "partner-component": "PARTNER_COMPONENT"
    }
    public static PAGE_SIZE: number = 10;
    public static USERNAME: string = "USERNAME";
    public static COST_MODULE_MAP: any = {
        "USERS": "USERS",
        "QE360SCRIPTLESS": "QE360_SCRIPTLESS",
        "QE360SCRIPTED": "QE360_SCRIPTED",
        "RANDOMTESTDATA": "RANDOM_TEST_DATA",
        "DESIGNCOPILOT": "DESIGN_COPILOT",
        "UTILITIES": "UTILITIES"
    }
    public static DEBOUNCING_TIME = 500;
 }